<template>
  <el-cascader v-if="type === 'select'" v-bind="$attrs" class="j-industry-select" v-model="industry" :options="industryArray" @change="industryChange" :separator="textSeparator" :clearable="clearable" />
  <span v-else class="j-industry-text">{{industryText}}</span>
</template>

<script>
import JIndustryMixins from './mixins'
export default {
  name: "JIndustry",
  mixins: [JIndustryMixins],
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    type: { // ['text', 'select']
      type: String,
      default: 'text'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    textSeparator: { // 文本分隔符
      type: String,
      default: '/'
    },
    separator: { // 父子字段分割
      type: String,
      default: ','
    },
    valueType: { // String/Array 返回类型
      type: String,
      default: 'String'
    }
  },
  watch: {
    value (nv) {
      this.updateData(nv)
    }
  },
  data () {
    return {
      industry: [],
      industryText: ''
    }
  },
  created() {
    this.updateData(this.value)
  },
  methods: {
    updateText () {
      this.industryText = this.industry.map(key => this.industryMap[key] || key).join(this.textSeparator)
    },
    updateData (value) {
      if (Array.isArray(value)) this.industry = value
      else this.industry = String(value).split(this.separator)
      if (this.type !== 'select') this.updateText()
    },
    industryChange (v) {
      if (this.valueType === 'Array') this.$emit('input', v)
      else this.$emit('input', v.join(this.separator))
      this.$emit('change', v, v.map(i => this.industryMap[i]))
    }
  }
}
</script>

<style lang="scss">
.j-industry-select {
  width: 100%;
}
</style>
